import React, { PureComponent } from 'react';
import EventModel from '../../../../utils/tracking/models';
import { trackGAEvent } from '../../../../client/utils/third_party_trackers/ga';
import PropTypes from 'prop-types';

class Social extends PureComponent {
  handleFollowLinkTracking(network, index) {
    const { property } = network;

    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'Top Nav Follow Us Click',
      `nav${property}`,
      'socialFollow',
      `socialNavigation ${property}`,
      index + 1
    );
    this.props.trackClick(clickEvent.getTrackingObject());

    trackGAEvent({
      eventCategory: 'Social',
      eventAction: 'Top Nav Follow Us',
      eventLabel: property
    });
  }

  render() {
    return (
      <div className="masthead__social">
        <span className="masthead__social-label">Follow</span>
        <ul className="masthead__social-list">
          {this.props.data.map((network, index) => (
            <li key={network.url} className="masthead__social-item">
              <a
                href={network.url}
                className={`masthead__social-button masthead__social-button--${
                  network.property
                }`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  this.handleFollowLinkTracking(network, index);
                }}
              >
                <i className={`icon-${network.property}`} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

Social.propTypes = {
  trackClick: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

Social.defaultProps = {
  trackClick: () => {}
};

export default Social;
